$shm_showcase_table $mol_grid
	entries /
	row_height 64
	col_ids /
		\number
		\title
		\fqn
		\preview
		\description
	Cell_text* $mol_grid_cell
		attr *
			^
			column <= cell_column* \
		sub <= cell_content* /
	Name* $mol_link
		title <= entry_title* \
		arg <= entry_arg* *
	Preview* $shm_showcase_preview
		entry_id <= preview_id* \
